import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ComboMaterial } from "../../../core/combo-material";
import { MaterialService } from "../../../services/material/material.service";


@Component({
    selector: 'combo-material',
    templateUrl: './combo-material.component.html',
    styleUrls: ['./combo-material.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboMaterialComponent implements OnInit {

    @ViewChild('comboMaterial', {static: false}) comboMaterial: any;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado = false;
    @Input() label = "Material";

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private materialService: MaterialService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.materialService.getAllCombo().subscribe((materials: ComboMaterial[]) => {
                this.dados = materials;
                this.preencherCombo();
            });
        }, 0);

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }

}